import { apiClient } from './client';
import type { Enrollment, CreateEnrollmentResult } from '../types';

export const provisioningApi = {
  list: async (firmId: number): Promise<Enrollment[]> => {
    const response = await apiClient.get(`/api/admin/firms/${firmId}/enrollments`);
    return response.data;
  },

  create: async (firmId: number, expiresInDays: number | null): Promise<CreateEnrollmentResult> => {
    const response = await apiClient.post(`/api/admin/firms/${firmId}/enrollments`, { expiresInDays });
    return response.data;
  },

  revoke: async (firmId: number, enrollmentId: number): Promise<void> => {
    await apiClient.delete(`/api/admin/firms/${firmId}/enrollments/${enrollmentId}`);
  },
};
